"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

// javascript-accessible copy of the colors contained in the colors.less file
ngModule.factory("tlColors", function () {
  return {
    WHITE: "#FFFFFF",
    BLACK: "#000000",
    FUSCHIA: "#A52694",
    DARK_YELLOW: "#ffc902",
    // NEW COLORS

    NEW_LIGHT_BLUE: "#39BEE7",
    NEW_BLUE_1: "#0069C0",
    NEW_BLUE_2: "#5D9CEC",
    NEW_PURPLE_1: "#564AA3",
    NEW_PURPLE_2: "#7266BA",
    NEW_GREEN_1: "#2B957A",
    NEW_GREEN_2: "#37BC9B",
    NEW_GREEN_3: "#1E983B",
    NEW_GREEN_4: "#27C24C",
    NEW_RED_1: "#EC2121",
    NEW_RED_2: "#F05050",
    NEW_ORANGE_1: "#F77600",
    NEW_ORANGE_2: "#FF902B",
    NEW_BLACK_1: "#131E26",
    // NEW_BLUE_1
    CAPITAL: "#0069C0",
    CAPITAL_SIMULES: '#cddef5',
    // NE_ORANGE_1
    INTERET: "#F77600",
    INTERET_SIMULES: '#FFB56B',
    // NEW_GREEN_1:
    COMMISSION: "#2B957A",
    COMMISSION_SIMULEES: '#77F079',
    // NEW_BLUE_1
    FIXE: "#0069C0",
    // NEW_ORANGE_1
    VARIABLE: "#F77600",
    // NEW_GREEN_1
    STRUCTURE: "#2B957A",
    DATE_VISUALISATION: '#4DC100',
    COURBE_TAUX_1: '#4DC100',
    COURBE_TAUX_2: '#0069C0',
    COURBE_TAUX_3: '#F77600',
    GREY2: '#BEBEBE',
    PREPARATION_DEMANDE: '#0083de',
    ATTENTE_ATTRIBUTION: '#ffc902',
    ATTRIBUEE: '#4DC100',
    TERMINEE: '#000000'
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/tlColors.js
// module id = 3019
// module chunks = 13